




















































































































































































































import {
  defineComponent, reactive, computed, watch, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import GroupAddressEditor from '@/components/GroupAddressEditor.vue';
import ViewOnlyGuard from '@/components/ViewOnlyGuard.vue';

import CommonDropzoneWithImageUpload from '@/components/CommonDropzoneWithImageUpload.vue';
import CommonHandicraftGroupSelector from '@/components/Selector/CommonHandicraftGroupSelector.vue';
import CommonHandicraftSubGroupSelector from '@/components/Selector/CommonHandicraftSubGroupSelector.vue';
import CommonHandicraftTypeSelector from '@/components/Selector/CommonHandicraftTypeSelector.vue';
import CommonCreatorSelector from '@/components/Selector/CommonCreatorSelector.vue';
import CommonMultiCreatorsSelector from '@/components/Selector/CommonMultiCreatorsSelector.vue';
import CommonLearningCenterSelector from '@/components/Selector/CommonLearningCenterSelector.vue';
import CommonYearSelector from '@/components/Selector/CommonYearSelector.vue';
import CommonKnowledgeSelector from '@/components/Selector/CommonKnowledgeSelector.vue';
import CommonGeolocationInput from '@/components/CommonInput/CommonGeolocationInput.vue';
import CommonTagsMultiSelector from '@/components/Selector/CommonTagsMultiSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonImageTable from '@/components/Table/CommonImageTable.vue';

import getCreatorsQuery from '@/gql/getCreators.gql';
import getHandicraft from '@/gql/getHandicraft.gql';
import createHandicraft from '@/gql/createHandicraft.gql';
import updateHandicraft from '@/gql/updateHandicraft.gql';

import log from '@/table/log';

const HandicraftEditor = defineComponent({
  setup() {
    /* ===== Form ===== */
    const form = reactive({
      // ---- Type ---- // ---- [0]
      handicraftType: '',
      handicraftGroup: '',
      handicraftSubGroup: '',
      recordedYear: '',
      itemNo: '',
      displayId: '',
      // ---- Information ---- // [1]
      name: '',
      createdYear: 2000,
      creators: [],
      // ---- Details ---- // [2]
      cultureGroup: '',
      size: '',
      material: '',
      technique: '',
      description: '',
      background: '',
      footnote: '',
      tags: [],
      // ---- Living place ---- // [5]
      geolocation: {
        lat: '',
        long: '',
      },
      geolocationText: '',
      address: {
        province: {
          id: '',
          name: '',
        },
        postcode: '',
        district: {
          id: '',
          name: '',
        },
        amphur: {
          id: '',
          name: '',
        },
        address: '',
      },
      website: '',
      learningCenter: '',
      // ---- Image ---- // [4]
      images: [],
      backgroundColor: 'white',
      mainImage: {},
      knowledge: '',
      logs: [],
    });

    /* ==== Get meta data ==== */
    const { route } = useRouter();
    // Try to destructor but doesn't work Q^Q
    // eslint-disable-next-line
    const mode = route.value.meta.mode;
    const modeDisplay = computed(() => {
      if (mode === 'create') return 'เพิ่ม';
      if (mode === 'edit') return 'แก้ไข';
      if (mode === 'view') return 'ดู';
      return '';
    });

    // ============================================= //
    // This function use with Creator multiselector  //
    function transformCreatorToLibFormat(arr: { firstName: string; lastName: string; id: number }[]) {
      if (!arr) return [];
      const temp: any = [];
      arr.forEach((element) => {
        temp.push(`${element.firstName} ${element.lastName} value: ${element.id}`);
      });
      return temp;
    }

    const computedCreators = computed(() => {
      const temp: any = [];
      form.creators.forEach((element: any) => {
        temp.push(parseInt(element.split(' value: ')[1], 10));
      });
      return temp;
    });
    // ============================================= //

    /* ==== Get value when enter edit mode */
    const isQueryEnabled = ref(true);
    const { result: getHandicraftResult } = useQuery(getHandicraft, computed(() => ({
      id: route.value.params.handicraftId,
    })), () => ({
      fetchPolicy: 'network-only',
      enabled: isQueryEnabled.value,
    }));
    watch(getHandicraftResult, () => {
      const handicraft = useResult(getHandicraftResult, null, (data) => data.handicraft);
      const item = handicraft.value;
      if (item) isQueryEnabled.value = false; // if value is loaded, disable next query
      form.handicraftType = item?.handicraftType?.id;
      form.handicraftGroup = item?.handicraftGroup?.id;
      form.handicraftSubGroup = item?.handicraftSubGroup?.id;
      form.recordedYear = item?.recordedYear + 543;
      form.itemNo = item?.itemNo;
      form.displayId = item?.displayId;
      // ---- Information ---- // [1]
      form.name = item?.name;
      form.createdYear = item?.createdYear + 543;
      // form.creatorId: undefined,
      // // ---- Details ---- // [2]
      form.cultureGroup = item?.cultureGroup;
      form.size = item?.size;
      form.material = item?.material;
      form.technique = item?.technique;
      form.description = item?.description;
      form.background = item?.background;
      form.footnote = item?.footnote;
      form.tags = item?.tags;
      // // ---- Living place ---- // [5]
      form.address.address = item?.groupAddress?.address === null ? '' : item?.groupAddress?.address;
      form.address.province.id = item?.groupAddress.province === null ? '' : item?.groupAddress.province?.id;
      form.address.amphur.id = item?.groupAddress.amphur === null ? '' : item?.groupAddress.amphur?.id;
      form.address.district.id = item?.groupAddress.district === null ? '' : item?.groupAddress.district?.id;
      form.address.postcode = item?.groupAddress?.postcode === null ? '' : item?.groupAddress?.postcode;
      form.geolocationText = `${item?.geolocation?.lat ? `${item?.geolocation.lat}, ` : ''}${item?.geolocation?.long ? item?.geolocation.long : ''}`;
      form.website = item?.website;
      // },
      form.learningCenter = item?.learningCenter?.id;
      form.knowledge = item?.knowledge?.id || '';
      // // ---- Image ---- // [4]
      form.images = item?.images;
      form.mainImage = item?.mainImage;
      // form.backgroundColor: '',
      form.logs = item?.logs;
      form.creators = transformCreatorToLibFormat(item?.creators);
    });

    /* ===== Menu manager ===== */
    const editorMenu = [
      { id: 0, status: true, display: 'ประเภทของชิ้นงานและรหัส' },
      { id: 1, status: false, display: 'ข้อมูลชิ้นงาน' },
      { id: 2, status: false, display: 'รายละเอียดชิ้นงาน' },
      { id: 3, status: false, display: 'แหล่งที่มา' },
      { id: 4, status: false, display: 'ภาพประกอบ' },
      { id: 5, status: false, display: 'องค์ความรู้' },
      { id: 6, status: false, display: 'ประวัติการแก้ไข' },
    ];
    function changeActiveMenu(index: number) {
      for (let i = 0; i < editorMenu.length; i += 1) {
        if (editorMenu[index]?.id === i) editorMenu[i].status = true;
        else editorMenu[i].status = false;
      }
    }
    // ========================== //

    /* ==== Validate to submit button ==== */
    const validated = computed(() => {
      if (form.handicraftGroup === '' || form.handicraftGroup === undefined) return false;
      if (form.recordedYear === '' || form.recordedYear === undefined) return false;
      if (form.handicraftType === '' || form.handicraftType === undefined) return false;
      if (form.name === '' || form.name === undefined) return false;
      return true;
    });

    const saveModal = ref(null);
    function pendingSubmit() {
      if (validated.value) (saveModal.value as any).open();
    }
    // ========================= //

    const computedGeolocation = computed(() => {
      const text = form.geolocationText?.split(', ');
      if (!text) return { lat: 0.00, long: 0.00 };
      return {
        lat: parseFloat(text[0]),
        long: parseFloat(text[1]),
      };
    });

    const computedImages = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.images?.forEach((element: any) => {
        temp.push(parseInt(element.id, 10));
      });
      return temp;
    });

    const handicraftInput = computed(() => ({
      createdYear: (form.createdYear - 543) || (new Date(Date.now())).getFullYear() - 543,
      name: form.name,
      itemNo: form.itemNo || '',
      handicraftGroup: parseInt(form.handicraftGroup, 10),
      handicraftSubGroup: parseInt(form.handicraftSubGroup, 10),
      handicraftType: parseInt(form.handicraftType, 10),
      creators: computedCreators.value,
      recordedYear: parseInt(form.recordedYear, 10) - 543,
      tags: form.tags || [],
      website: form.website,
      technique: form.technique,
      size: form.size,
      material: form.material,
      // mainImage: form.mainImage,
      knowledge: form.knowledge === '' ? null : form.knowledge,
      images: computedImages.value,
      footnote: form.footnote,
      description: form.description,
      cultureGroup: form.cultureGroup,
      background: form.background,
      geolocation: computedGeolocation.value,
      groupAddress: {
        address: form.address.address || '',
        district: parseInt(form.address.district.id, 10) || null,
        amphur: parseInt(form.address.amphur.id, 10) || null,
        province: parseInt(form.address.province.id, 10) || null,
        postcode: form.address.postcode || '',
      },
      learningCenter: parseInt(form.learningCenter, 10),
    }));

    // ===== Create Mutation =====
    const createHandicratfMutation = useMutation(createHandicraft,
      () => ({
        variables: {
          input: handicraftInput.value,
        },
        refetchQueries: ['getHandicraftTypes', 'getHandicrafts'],
      }));
    // ========================= //

    // ==== Update Mutation ==== //
    const updateHandicraftMutation = useMutation(updateHandicraft,
      () => ({
        variables: {
          id: route.value.params.handicraftId,
          input: handicraftInput.value,
        },
        refetchQueries: ['getHandicraftTypes', 'getHandicrafts'],
      }));
    // ========================= //

    // ==== Computed Mutation ==== //
    const computedMutation = computed(() => {
      if (mode === 'create') return createHandicratfMutation;
      return updateHandicraftMutation;
    });

    function onImageUploadDone(newImage: never) {
      if (!form.images) form.images = [];
      form.images.push(newImage);
    }

    return {
      onImageUploadDone,
      editorMenu,
      mode,
      modeDisplay,
      changeActiveMenu,
      form,
      log,
      computedMutation,
      getHandicraft,
      validated,
      pendingSubmit,
      saveModal,
    };
  },
  components: {
    GroupAddressEditor,
    ViewOnlyGuard,
    CommonDropzoneWithImageUpload,
    CommonHandicraftGroupSelector,
    CommonHandicraftSubGroupSelector,
    CommonHandicraftTypeSelector,
    CommonCreatorSelector,
    CommonMultiCreatorsSelector,
    CommonLearningCenterSelector,
    CommonYearSelector,
    CommonKnowledgeSelector,
    CommonGeolocationInput,
    CommonTagsMultiSelector,
    CommonConfirmDialog,
    CommonImageTable,
  },
  props: {
    role: {},
  },
});

export default HandicraftEditor;
